import { IconName } from '@blueprintjs/core'
import React, { useState } from 'react'
import { FormattedPriceInput, FormattedPriceInputProps } from '../../components/FormattedPriceInput'

export interface ExpressListPriceInputProps extends FormattedPriceInputProps {
  leftIconFocused?: IconName
  leftIconUnfocused?: IconName
  nonClearable?: boolean
}

// A price input for the Express List page.
// Basically FormattedPriceInput, but it allows providing certain icons depending on whether the input is focused or not.
export const ExpressListPriceInput: React.FC<ExpressListPriceInputProps> = props => {
  const { leftIconFocused, leftIconUnfocused, onValueChange, nonClearable, ...otherProps } = props

  const leftIcon = props.leftIcon || 'dollar'
  const leftIconFocusedWithDefault = leftIconFocused || leftIcon
  const leftIconUnfocusedWithDefault = leftIconUnfocused || leftIcon

  const [focused, setFocused] = useState(false)

  const onValueChangeBetter = React.useCallback(
    (valueAsString: string) => {
      if (nonClearable) {
        // If the strategy / admin settings provide a hardcoded shipping price (for example), we won't give the users
        // an option to clear shipping price and use calculated shipping on a per-item basis.
        // It would make the form change a lot, so let's avoid that. They also couldn't undo this.
        const nonEmptyValue = valueAsString === '' ? ' ' : valueAsString
        onValueChange(nonEmptyValue)
      } else {
        onValueChange(valueAsString)
      }
    },
    [onValueChange, nonClearable]
  )

  return (
    <FormattedPriceInput
      {...otherProps}
      onValueChange={onValueChangeBetter}
      leftIcon={focused ? leftIconFocusedWithDefault : leftIconUnfocusedWithDefault}
      onFocus={event => {
        setFocused(true)

        if (props.onFocus) props.onFocus(event)
      }}
      onBlur={event => {
        setFocused(false)

        if (props.onBlur) props.onBlur(event)
      }}
    />
  )
}
